/**
 * Arrows Up brand tokens, taken from goarrowsup.com. The single source of
 * brand colours and fonts for platform-ui; the MUI theme is built from these.
 */
export const auBrand = {
  color: {
    sand: "#eceadf", // background · primary-50
    ink: "#010f16", // foreground · phantom-pain-950
    white: "#ffffff",
    orange: "#f28805", // primary-300
    signal: "#ee4c21", // primary-400, the brand colour
    redOrange: "#e8342e", // primary-500
    deepRed: "#c51b16", // primary-600, orange for text on light grounds
    destructive: "#e7000b",
    success: "#2d7a3e", // not a site token; the site has no success colour
    inkMuted: "#010f1699", // ink at 60%, the lightest allowed for small text
    inkDisabled: "#010f1661", // ink at 38%
    hairline: "#010f1626", // ink at 15%
    rule: "#010f1640", // ink at 25%, the strongest allowed border
  },
  font: {
    display: '"Space Grotesk", sans-serif',
    body: '"Inter", sans-serif',
  },
} as const;
